<script lang="ts">
  import { Col, Form, FormGroup } from "sveltestrap";
  import Card from "../../../Core/Card.svelte";
  import Typeahead from "svelte-typeahead";
  import { DatasetshowsinRightSide, RTLSupport } from "../../../../utils/Constant/Constant";
  import {states} from "../../../../Data/Forms/Widgets/Widgets"
  let events = [];
  let data:{abbr:string, state:string}[] = states
</script>
<Col sm="12">
    <Card headerTitle={RTLSupport} cardHeaderprops="pb-0">
      <div slot="customheader">
        <span>{DatasetshowsinRightSide}</span>
      </div>
      <div slot="contentbody">
        <div id="rtl-support">
          <Form class="theme-form">
            <FormGroup>
              <Typeahead
                  class="typeahead"
                  label=""
                  placeholder="Countries"
                  {data}
                  extract={(item) => item.state}
                  on:select={({ detail }) => events = [...events, detail]}
                  on:clear={() => events = [...events, "clear"]}
                />
            </FormGroup>
          </Form>
        </div>
      </div>
    </Card>
</Col>